import { createAsyncThunk } from '@reduxjs/toolkit';
import { addLoading, removeLoading } from '../appAction';
import { Enums, Paths, Value } from '@utils/constants';
import { axios } from '@utils/lib';

export const getLocationListAsync = createAsyncThunk(
  'api/getLocationListAsync',
  async (request: ILocationListParams, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const { dbId, query } = request;
    const searchQuery: Record<string, string> = {
      'pagination[page]': query.page ?? Value.TABLE_PAGE_INIT,
      'pagination[pageSize]': query.pageSize ?? Value.TABLE_PAGE_SIZE,
      sort: 'id:desc',
    };
    if (query.name) searchQuery['filters[name][$contains]'] = query.name;

    const params = new URLSearchParams(searchQuery).toString();

    try {
      const { data } = await axios.request<IListRes<ILocationListData>>(
        Enums.HTTP_METHOD.GET,
        Paths.LOCATION_LIST.replace(':db', String(dbId)) + '?' + params,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const createLocationAsync = createAsyncThunk(
  'api/createLocationAsync',
  async (data: ICreateLocation, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const { dbId, name } = data;
    try {
      const { data } = await axios.request<ICreateLocattionRes>(
        Enums.HTTP_METHOD.POST,
        Paths.LOCATION_LIST.replace(':db', dbId),
        {
          name,
        },
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);
